import reducer from './reducer'

import * as feePaymentsOperations from './operations'
import * as feePaymentsSelectors from './selectors'

export { feePaymentsOperations, feePaymentsSelectors }

export default reducer
